import { useEffect, useState } from 'react';

// Returns a debounced copy of `value` that updates once it stops changing.
// It returns `undefined` until the first value settles.
const useDebounce = <T>(value: T, delayMs: number): T | undefined => {
  const [debouncedValue, setDebouncedValue] = useState<T>();

  useEffect(() => {
    const timeoutId = setTimeout(() => setDebouncedValue(value), delayMs);

    return () => clearTimeout(timeoutId);
  }, [value, delayMs]);

  return debouncedValue;
};

export default useDebounce;
